import { render } from "./flag.vue?vue&type=template&id=029b181c&ts=true"
import script from "./flag.vue?vue&type=script&lang=ts"
export * from "./flag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__